import { render, staticRenderFns } from "./KFooter.vue?vue&type=template&id=03e4fdcf&"
import script from "./KFooter.vue?vue&type=script&lang=ts&"
export * from "./KFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports